// extracted by mini-css-extract-plugin
export default {"selectAllToggleText":"dftmV","selectAllIcon":"XTKcK","selectAllToggle":"mULVH"};